exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".simple-table[data-v-26f31a0e]{--custom-col-structure:repeat(4,minmax(min-content,auto)) minmax(min-content,max-content)}.manufacturer-description[data-v-26f31a0e] :last-child{margin-bottom:0}.manufacturer-description.with-gradient[data-v-26f31a0e]{position:relative;max-height:100px;overflow:hidden}.manufacturer-description.with-gradient[data-v-26f31a0e]:before{content:\"\";position:absolute;bottom:0;left:0;width:100%;height:50px;background-image:linear-gradient(0deg,#fff,transparent)}", ""]);

// exports
